/* eslint-disable prettier/prettier */
import React, { useEffect, useRef, useState } from 'react';
import { CForm, CFormLabel, CFormInput, CButton, CCard, CCardBody, CCardHeader, CCol, CRow, CFormCheck, CNav, CNavItem, CNavLink } from '@coreui/react';
import { Link, useLoaderData } from 'react-router-dom';
import AxiosInstance from 'src/components/Axios';
import { useNavigate } from "react-router-dom";
// import AddProductInfo from 'src/components/product/AddProductInfo';
// import ViewProductInfo from 'src/components/product/ViewProductInfo';
// import BasicModal from 'src/components/Modal';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ProductCategories from 'src/components/product/ProductCategories';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MyToastify from 'src/components/myComponents/MyToactify';
// import WarningWhenEditing from 'src/components/product/WarningWhenEditing';
import Tab from 'react-bootstrap/Tab';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import ProductRelated from 'src/components/product/ProductRelated';
import ProductMedia from 'src/components/product/ProductMedia';
import ProductAttributes from 'src/components/product/ProductAttributes';
import ProductAvailability from 'src/components/product/ProductAvailability';
import ProductPrice from 'src/components/product/ProductPrice';
import ProductGeneral from 'src/components/product/ProductGeneral';
import ProductMediaHover from 'src/components/product/ProductMediaHover';
import ProductVideo from 'src/components/product/ProductVideo';
import ProductConfiguration from 'src/components/product/ProductConfiguration';
import scrollToTop from 'src/components/store/scrollToTop';
import LangugesPanel from './LangugesPanel';
import { SentimentVeryDissatisfiedSharp } from '@mui/icons-material';


const urlApi = '/products';
const urlRouter = '/products';
const ApiParams = {
  "g[0]": "product:read",
  "g[1]": "product:admin",
  "g[2]": "product:category",
  "g[3]": "product:attributeItems",
  "g[4]": "product:media",
  "g[5]": "product:hover",
  // "g[6]": "product:productInfos"
  "g[6]": "product:translation",
  "g[7]": "product:language",
  "g[8]": "product:warrantyPeriod"
};

const cabinetLink = process.env.REACT_APP_SITE_URL;

export async function LoaderProductsUpdate({ params }) {
  if (Object.keys(params).length != 0) {
    let res = await AxiosInstance.get(`${urlApi}/${params.pid}`, { params: ApiParams }).then((response) => {
      // console.log("get /api/products/ response", response);
      return response;
    });
    return res;
  }
  return false;
}


const ProductForm = () => {
  const navigate = useNavigate();
  const { data } = useLoaderData();
  // console.log(data, 'data')

  const [MyData, setMyData] = useState(data);
  // console.log('MyData', MyData)
  useEffect(() => {
    // console.log('data', data);
    // якщо видалений продукт редірект на всі продукти
    if (data?.deleted) {
      navigate(urlRouter);
    }
    setMyData(data);
    scrollToTop();
  }, [data]);

  const [name, setName] = useState((data != undefined) ? data.name : '');
  //Змінив showModal на false
  // const [showModal, setShowModal] = useState(true);
  const [update, setUpdate] = useState(false);
  const [isNew, setIsNew] = useState((data != undefined && data?.isNew != null) ? data?.isNew : false)
  const [isSalle, setIsSalle] = useState(data?.isSalle ?? false);
  const [attrCategoryId, setAttrCategoryId] = useState();
  //стани для мовноі панелі
  const [language, setLaguage] = useState('');

  // Викликає popup з власного компонента
  const popup = MyToastify();
  // Текст для popup
  const popupTextSuccess = "Товар збережено";

  useEffect(() => {
    if (MyData?.name) {
      setName(MyData.name);
    };
  }, [MyData]);

  // Відкрити/закрити вікно з попередженням про редагування товару
  // const [openWarning, setOpenWarning] = useState(true);

  // // Функція для оновлення даних
  // const getProductData = async () => {
  //   try {
  //     const response = await AxiosInstance.get(`${urlApi}/${MyData.id}`, { params: ApiParams });
  //     console.log('products/id/ get response', response);
  //     setMyData(response.data);
  //   } catch (error) {
  //     console.error("Помилка запиту за даними товару: ", error);
  //   };
  // };

  const handleSubmit = (event, dataFromComponent) => {
    event.preventDefault();
    // console.log('dataFromComponent', dataFromComponent);
    if (data != undefined) {
      dataFromComponent.language = data.language ? `/api/languages/${data.language.id}` : `/api/languages/1`;
      const response = AxiosInstance.put(`${urlApi}/${data.id}`, dataFromComponent, { params: ApiParams }).then((response) => {
        // console.log('products/id/ put response', response);
        if (response.status === 200) {
          // Popup про успішні зміни
          popup.toastifySuccess(popupTextSuccess);
          setMyData(response.data);
          scrollToTop();
        }
      });
    } else {
      dataFromComponent.language = `/api/languages/1`;
      const response = AxiosInstance.post(`${urlApi}`, dataFromComponent, { params: ApiParams }).then((response) => {
        // console.log('post product response', response);
        if (response.status === 201) {
          return navigate(`${urlRouter}/update/${response.data.id}`);
        }
      });
    };
  };

  useEffect(() => {
    AxiosInstance.get(`/categories`, {
      headers: { 'accept': 'application/json' }, params: {
        'g[0]': 'cat:read',
      }
    }).then((response) => {
      const [data] = response.data.filter(cat => (cat.type === 'attributes' && cat.slug === 'product_attributes'));
      if (data !== undefined) {
        setAttrCategoryId(data.id)
      }
    });
  }, [])

  // const actionShowModal = (rez) => {
  //   setShowModal(rez);
  //   if (!rez)
  //     setUpdate(true);
  // };

  // // Функція для закриття модального вікна з попередженням про редагування товару
  // const handleCloseWarning = () => {
  //   // Закрити модальне з попередженням
  //   setOpenWarning(false);
  // };
  // console.log('data', data)
  return (
    <>
      {/* Popup про успішні зміни (справа зверху) */}
      <ToastContainer />

      {/* Модальне вікно з попередженням про редагування товару */}
      {/* {data !== undefined && <WarningWhenEditing openWarning={openWarning} handleCloseWarning={handleCloseWarning} />} */}

      {data !== undefined &&
        <>
          <Row>
            <Col sm={8}>
              <h1 className="mb-3">{name}</h1>
            </Col>
            <Col sm={4}>
              {/* Перейти на товар на сайті */}
              <Link to={`${cabinetLink}/product/${MyData.id}`} className="mb-3" target='_blank'>
                <CButton className="mb-3" color="secondary" variant="outline" title="Перейти на товар на сайті">Перейти на сайт</CButton>
              </Link>
            </Col>
          </Row>
          <hr style={{ marginTop: '15px', marginBottom: '30px' }} />

          {!MyData.show && <p className='alert alert-warning'>Товар не продається! (див. пункт наявніть)</p>}
          {(MyData.price <= 0 || MyData.price == null) && <p className='alert alert-warning'>Вкажіть ціну на товар! (див. пункт ціни)</p>}
        </>
      }


      {/* //зміни - мовна панель*/}
      <div className='col d-flex justify-content-end'>
        {data !== undefined && <LangugesPanel data={MyData} setMyData={setMyData} setLaguage={setLaguage} language={language} />}
      </div>
      {/* //зміни */}




      <Tab.Container id="left-tabs-example" defaultActiveKey="info">
        <Row>
          <Col sm={2}>
            <Nav variant="pills" className="flex-column">
              {
                (MyData != undefined) &&
                <Nav.Item>
                  <Nav.Link eventKey="img">Зображення</Nav.Link>
                </Nav.Item>
              }
              {
                (MyData != undefined) &&
                <Nav.Item>
                  <Nav.Link eventKey="video">Відео</Nav.Link>
                </Nav.Item>
              }
              {
                (MyData != undefined) &&
                <Nav.Item>
                  <Nav.Link eventKey="show">Наявність</Nav.Link>
                </Nav.Item>
              }
              {
                (MyData != undefined) &&
                <Nav.Item>
                  <Nav.Link eventKey="price">Ціни</Nav.Link>
                </Nav.Item>
              }
              <Nav.Item>
                <Nav.Link eventKey="info">Загальні</Nav.Link>
              </Nav.Item>
              {
                (MyData != undefined) &&
                <Nav.Item>
                  <Nav.Link eventKey="configuration">Комплектація</Nav.Link>
                </Nav.Item>
              }
              {/* {
                (MyData != undefined) &&
                <Nav.Item>
                  <Nav.Link eventKey="product_info">Інформація про товар</Nav.Link>
                </Nav.Item>
              } */}
              {
                (MyData != undefined) &&
                <Nav.Item>
                  <Nav.Link eventKey="attributes">Атрибути</Nav.Link>
                </Nav.Item>
              }
              {
                (MyData != undefined) &&
                <Nav.Item>
                  <Nav.Link eventKey="category">Категорії</Nav.Link>
                </Nav.Item>
              }
              {
                (MyData != undefined) &&
                <Nav.Item>
                  <Nav.Link eventKey="releted">Супутні товари</Nav.Link>
                </Nav.Item>
              }
            </Nav>
          </Col>
          <Col sm={10}>
            <Tab.Content>
              <Tab.Pane eventKey="img">
                {/* Додавання зображення */}
                {
                  (MyData != undefined) &&
                  <ProductMedia
                    data={data} MyData={MyData} setMyData={setMyData}
                    LoaderProductsUpdate={LoaderProductsUpdate} toastifySuccess={popup.toastifySuccess}
                  />
                }
                {/* Додавання зображення для hover */}
                {/* {
                  (MyData != undefined) &&
                  <>
                    <h2>Зображення Hover</h2>
                    <ProductMediaHover
                      data={data} myData={MyData} setMyData={setMyData}
                      urlApi={urlApi}
                      // LoaderProductsUpdate={LoaderProductsUpdate}
                      toastifySuccess={popup.toastifySuccess} toastifyWarning={popup.toastifyWarning}
                    />
                  </>
                } */}
              </Tab.Pane>
              <Tab.Pane eventKey="video" mountOnEnter unmountOnExit>
                {/* Додавання відео */}
                {
                  (MyData != undefined) &&
                  <ProductVideo handleSubmit={handleSubmit} MyData={MyData} />
                }
              </Tab.Pane>
              <Tab.Pane eventKey="show">
                {/* Наявність */}
                {
                  (MyData != undefined) &&
                  <ProductAvailability handleSubmit={handleSubmit} data={MyData} isNew={isNew} setIsNew={setIsNew} />
                }
              </Tab.Pane>
              <Tab.Pane eventKey="price">
                {/* Ціна */}
                {
                  (MyData != undefined) &&
                  <ProductPrice handleSubmit={handleSubmit} MyData={MyData} isSalle={isSalle} setIsSalle={setIsSalle} />
                }
              </Tab.Pane>
              <Tab.Pane eventKey="info">
                {/* Загальна Інформація про товар */}
                <ProductGeneral
                  data={MyData}
                  // data={data} 
                  // MyData={MyData}
                  setMyData={setMyData}
                  handleSubmit={handleSubmit} />
              </Tab.Pane>
              {
                (MyData != undefined) &&
                <Tab.Pane eventKey="configuration">
                  {/* Комплектація до товару */}
                  <ProductConfiguration
                    // productInfos={MyData?.productInfos}
                    productId={MyData.id} />
                </Tab.Pane>
              }
              {/* <Tab.Pane eventKey="product_info">
                  Інформація про товар
                {
                  (data != undefined) ?
                    <>
                      <div className='row'>
                        <div className='col'> <h3>Інформація про товар</h3></div>
                        <div className='col d-flex justify-content-end'>
                          <BasicModal
                            show={showModal}
                            actionShowModal={actionShowModal}
                            title={`Додати інформацію про товар`}
                            content={
                              <AddProductInfo
                                actionShowModal={actionShowModal}
                                product={data.id}
                                toastifySuccess={popup.toastifySuccess}
                                toastifyWarning={popup.toastifyWarning}
                              />
                            }
                          />
                        </div>
                      </div>

                      <ViewProductInfo
                        product={data.id}
                        update={update}
                        showModal={showModal}
                        setUpdate={setUpdate}
                        actionShowModal={actionShowModal}
                        popup={popup} />
                    </>
                    : ''
                }
              </Tab.Pane> */}
              <Tab.Pane eventKey="attributes">
                {/* Атрибути */}
                {
                  (MyData != undefined && attrCategoryId !== undefined) &&
                  <ProductAttributes productId={MyData.id} categories={MyData.category} attributeItems={MyData.attributeItems} toastifySuccess={popup.toastifySuccess} type="products" parentAttrCategory={attrCategoryId} mainCategoryId={MyData.mainCategoryId} />
                }
              </Tab.Pane>
              <Tab.Pane eventKey="category">
                {/* Категорії */}
                {
                  (MyData != undefined) &&
                  <ProductCategories product_id={MyData.id} toastifySuccess={popup.toastifySuccess} toastifyWarning={popup.toastifyWarning} data={MyData} setIsNew={setIsNew} setMyData={setMyData} setIsSalle={setIsSalle} />
                }
              </Tab.Pane>
              <Tab.Pane eventKey="releted">
                {/* Супутні товари */}
                {
                  (data != undefined) && <ProductRelated product={data} />
                }
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container >


      {/* <hr style={{ marginTop: '55px', marginBottom: '55px' }} /> */}
      {/* Атрибути */}
      {/* <ProductAttributes productId={data.id} attributeItems={data.attributeItems} toastifySuccess={popup.toastifySuccess} type="products" /> */}
      {/* <hr style={{ marginTop: '55px', marginBottom: '55px' }} /> */}
      {/* Категорії */}
      {/* {(MyData != undefined) ? <ProductCategories product_id={MyData.id} toastifySuccess={popup.toastifySuccess} /> : ''} */}
      {/* <hr style={{ marginTop: '55px', marginBottom: '55px' }} /> */}
    </>
  );
};

export default ProductForm;